export class BrokerApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBrokers() {
    return this.#http.get('/Broker');
  }

  async createBroker(body) {
    return this.#http.post('/Broker', body);
  }

  async editBroker({ brokerId, ...body }) {
    return this.#http.put(`/Broker/${brokerId}`, body);
  }

  async deleteBroker({ brokerId }) {
    return this.#http.delete(`/Broker/${brokerId}`);
  }
}
